import type { FaireProductEntity } from "../../entity_types/product";

export const p_tp2eu3uyb3: FaireProductEntity = {
  token: "p_tp2eu3uyb3",
  type: "product",
  name: "NEW  Thanks a Bunch- Foiled Thank You Greeting Card",
  brandToken: "b_fcqyym5uay",
  brandName: "Nat Ellis Illustration",
  imageUrl:
    "https://cdn.faire.com/fastly/ec27865ac2737b8b812c94562f6bc59084b749c71d8c3312280b730d5620a57d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/353a6f3b0ee8e1b6e423f665fff51292e72c5b51c7b00cec92a915a127553f50.jpeg",
    "https://cdn.faire.com/fastly/b6121932f60c29010a1f0500b8e31b6c92f827b726a02fafa6a0901596e10af8.jpeg",
    "https://cdn.faire.com/fastly/9c78c5a7304eee7f105432a4dfafff2122e450d010a79b5326ebfad611587165.jpeg",
    "https://cdn.faire.com/fastly/9cef72cdf73ed5ecfcf43a5936d7d9a15616c1353435959e8c51d95a3844c9ca.jpeg",
  ],
  priceDollars: 2.01,
  description:
    "Thanks a Bunch- Foiled Thank You Greeting Card\n\nA cute and colourful card of  a cat surrounded by flowers with the slogan 'Thank a Bunch'.\n\nEach card comes with a bright pink envelope.\n\n★\tProduct Details ★\n\nPrinted onto beautiful 320gsm Veltique stock with gold foiled details.\n\n100% recycled and FSC Certified\n\nCard is black inside for your message.\n\nEach card comes in a biodegradable cello wrap.\n\nFull colour print\n\nMeasurements A6 105(w) x 148mm (h)\n\nPrinted by an independent manufacturer in the UK\n\nPhotographs © @girl_behindthelens / www.girlbehindthelens.co.uk\n\n",
  tags: [],
  msrpDollars: 4.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:06.503Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
